import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { propertiesAPI } from '../../API/properties';
import { allImage } from '../../Utils/allImageImport';
import ButtonControl from '../Common/Button';
import MainLoader from '../Common/Loader/MainLoader';
import Modal from '../Common/Modal';
import Toaster from '../Common/Toaster';

const PropertyDetailComponents = ({ details, handleRefresh }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const [requestModel, setRequestModal] = useState(false);
  const [toastError, setToastError] = useState({});
  const [toaster, setToaster] = useState(false);
  const [loading, setLoading] = useState(false);
  const [leadAndApplicantCount, setLeadAndApplicantCount] = useState({});

  useEffect(() => {
    if (details?._id) {
      handleGetLeadAndApplicantCount(details?._id);
    }
  }, [details?._id]);

  const handleGetLeadAndApplicantCount = async (id) => {
    const res = await propertiesAPI?.getCountOfApplicantAndLead(id);
    if (res && res?.status === true) {
      setLeadAndApplicantCount(res?.data || {});
      setLoading(false);
    } else {
      setToastError({
        title: 'API Fail',
        message: res?.data?.message || 'Something went to wrong!',
        type: 'error',
      });
      setToaster(true);
    }
  };

  const handleRequestModal = () => {
    setRequestModal(true);
  };

  const requestModalClose = () => {
    setRequestModal(false);
  };

  const handleUnListProperty = async () => {
    requestModalClose();
    if (details?._id || pathname?.split('/')[3]) {
      setLoading(true);
      const res = await propertiesAPI?.unListProperty(
        details?._id || pathname?.split('/')[3]
      );
      if (res && res?.status === true) {
        handleRefresh();
        setLoading(false);
        setToaster(true);
        setToastError({
          title: 'Success',
          message: res?.data?.message || 'Something went to wrong!',
          type: 'success',
        });
      } else {
        setLoading(false);
        setToastError({
          title: 'API Fail',
          message: res?.data?.message || 'Something went to wrong!',
          type: 'error',
        });
        setToaster(true);
      }
    }
  };

  const overview = [
    {
      image: allImage.badRoom,
      title: `${details?.bedrooms || 0} Bedrooms`,
    },
    {
      image: allImage.bathRoom,
      title: `${details?.bathrooms || 0} Bathrooms`,
    },
    {
      image: allImage.sqftIcon,
      title: `${
        (details?.square_footage &&
          details?.square_footage?.toString()?.replace('sqft', '')) ||
        'N/A'
      }  sqft`,
    },
    {
      image: allImage.dateIcon,
      title: new Date(details?.createdAt).toLocaleDateString(),
    },
  ];

  const detail = [
    {
      title: 'Monthly Rent',
      value: `$${details?.monthly_rent}`,
    },
    {
      title: 'Lease duration',
      value: details?.lease_duration,
    },
    {
      title: 'Pet policy',
      value: details?.pet_policy,
    },
    {
      title: 'Security deposit',
      value: `$${details?.security_deposit}`,
    },
  ];

  const utilitiesIcon = (key) => {
    switch (key) {
      case 'Cable':
        return allImage?.cableIcon;
      case 'Electric':
        return allImage?.electricIcon;
      case 'Gas':
        return allImage?.gasIcon;
      case 'Air Conditioning':
        return allImage?.acIcon;
      case 'Water':
        return allImage?.waterIcon;
      case 'Trash':
        return allImage?.trashIcon;
      case 'Telephone':
        return allImage?.telephoneIcon;
      case 'Sewer':
        return allImage?.sewerIcon;
      case 'Satellite':
        return allImage?.satelliteIcon;
      case 'Hot Water':
        return allImage?.hotWaterIcon;
      case 'High Speed Internet':
        return allImage?.wifiIcon;
      case 'Heat':
        return allImage?.heatIcon;
      default:
        return allImage?.electricIcon;
    }
  };

  const amenitiesIcon = (key) => {
    switch (key) {
      case 'Balcony or deck':
        return allImage?.balconyAndDeckIcon;
      case 'Disabled access':
        return allImage?.disabledAccessIcon;
      case 'Dishwasher':
        return allImage?.dishwasherIcon;
      case 'Air conditioning':
        return allImage?.acIcon;
      case 'Dryer':
        return allImage?.dryerIcon;
      case 'Furnished':
        return allImage?.furnishedIcon;
      case 'Garage parking':
        return allImage?.garageParkingIcon;
      case 'Hardwood floors':
        return allImage?.hardwoodFloorsIcon;
      case 'Off-street parking':
        return allImage?.offStreetParkingIcon;
      case 'Pool Bicycle storage':
        return allImage?.poolBicycleStorageIcon;
      case 'Security alarm':
        return allImage?.securityAlarmIcon;
      case 'Washer':
        return allImage?.washerIcon;
      default:
        return allImage?.electricIcon;
    }
  };

  const handleRedirectApplicant = () => {
    navigate(`/properties/property-detail/applicants/${details?._id}`, {
      state: { id: details?._id, details: details },
    });
  };

  return (
    <>
      <div className="property-detail-wrap">
        {toaster && (
          <Toaster
            title={toastError?.title}
            type={toastError?.type}
            message={toastError?.message}
            handleCloseToaster={() => setToaster(false)}
          />
        )}
        {loading && <MainLoader />}
        {/* <p>{details?.address}</p> */}
        <div className="lead-appli-info">
          <div className="property-lead-applicant">
            <span>
              <b>{leadAndApplicantCount?.leadCount || 0}</b> Inquiries 
            </span>
            <span>
              <b>{leadAndApplicantCount?.applicantCount || 0}</b> Applicants
            </span>
          </div>
          <div className="property-images">
            {details && details?.images?.length > 0 ? (
              <Swiper
                pagination={{
                  type: 'progressbar',
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="mySwiper"
              >
                {details?.images.map((list, index) => {
                  return (
                    <React.Fragment key={index}>
                      <SwiperSlide key={index}>
                        <div
                          className={`category ${
                            details?.status === 'Draft' ? 'draft' : (details?.status === 'Submitted for Listing' ? 'review' : 'listed')
                          }`}
                          key={index}
                        >
                          {details?.status}
                        </div>
                        <img
                          src={list?.url || allImage?.propertyDetailImage}
                          alt="detail-img"
                        />
                      </SwiperSlide>
                    </React.Fragment>
                  );
                })}
              </Swiper>
            ) : null}
          </div>
          <div className="property-applicant">
            <ButtonControl onClick={handleRedirectApplicant}>
              <span>Applicants</span>{' '}
              <img src={allImage?.rightIcon} alt="right-icon" />
            </ButtonControl>
          </div>
        </div>
        <div className="property-details">
          <div className="listing-row">
            <h5>Overview</h5>
            <ul className="overview-list">
              {overview.map((data, i) => {
                return (
                  <li key={i}>
                    <img src={data.image} alt="icon" />{' '}
                    <span>{data.title}</span>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="listing-row">
            <h5>Description</h5>
            <p>{details?.description || 'Description not available yet.'}</p>
          </div>
          <div className="listing-row">
            <h5>Listings</h5>
            <ul className="listings-list">
              {details?.listings && details?.listings?.length > 0
                ? details?.listings?.map((list, i) => {
                    return (
                      <li key={i}>
                        <span>{list?.name || ''}</span>
                      </li>
                    );
                  })
                : 'Currently property Listing details are not available yet.'}
            </ul>
          </div>
          <div className="listing-row">
            <h5>Details</h5>
            <ul className="details-list">
              {detail.map((data, i) => {
                return (
                  <li key={i}>
                    <span>{data.title}</span>
                    <h6>{data.value}</h6>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="listing-row">
            <h5>Amenities</h5>
            <ul className="amenites-utilities-list">
              {details?.amenities?.map((data, i) => {
                return (
                  <li key={i}>
                    <img src={amenitiesIcon(data)} alt="icon" />
                    <span>{data}</span>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="listing-row">
            <h5>Utilities included in rent</h5>
            <ul className="amenites-utilities-list">
              {details?.utilities?.map((data, i) => {
                return (
                  <li key={i}>
                    <img src={utilitiesIcon(data)} alt="icon" />
                    <span>{data}</span>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="listing-row mb-15">
            {(details?.listings && details?.listings?.length > 0) ||
              (details?.status === 'Listed' && (
                <ButtonControl kind="danger" onClick={handleRequestModal}>
                  Request to unlist property
                </ButtonControl>
              ))}
            <Modal
              className="unlist-modal"
              open={requestModel}
              onClose={() => requestModalClose()}
              title="Are you sure"
            >
              <p>your property will be unlisted within 24 hours</p>
              <div className="unlisted-btn">
                <ButtonControl
                  kind="secondary"
                  onClick={() => requestModalClose()}
                >
                  Cancel
                </ButtonControl>
                <ButtonControl kind="danger" onClick={handleUnListProperty}>
                  Unlist
                </ButtonControl>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
};

export default PropertyDetailComponents;
